import { ImageFileAttachment } from './index';

export interface __Tokens {
    access: string;
    expire_date: string;
    refresh: string;
}

export enum __AuthStatus {
    valid = 'valid',
    pending = 'pending',
    inValid = 'inValid',
    company = 'company',
}

export interface __UserData {
    id: number;
    full_name?: string;
    first_name?: string;
    last_name?: string;
    is_active: boolean;
    email: string;
    phone?: string;
    avatar?: ImageFileAttachment;
    job_title?: string;
    default_language?: number;
    time_zone?: number;
    username?: string;
    answers_count?: number;
    // subscription: { expire_date: string; subscription: __Subscription };
    // packages: {
    //     package__type: __PackageType;
    //     total_count: number;
    //     total_remaining: number;
    // }[];
    forms_count?: number;
    publishes_count?: number;
    is_email_active?: boolean;
    is_phone_active?: boolean;
    favorite_forms: number[];
}
export interface __Questioner {
    id: number;
    created_at: string;
    modified_at: string;
    first_name: string;
    last_name: string;
    email: string;
    answer_allowed_count: number;
    is_active: boolean;
    noting: boolean;
    ask_gps: boolean;
    auto_backup: boolean;
    view_answer_sheet: boolean;
    custom_upload: boolean;
    delete_before_upload: boolean;
    delete_after_upload: boolean;
    send_message: boolean;
    creator: number;
}
